<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" /> 
			<span>在线作业</span><i class="el-icon-arrow-right"></i>&nbsp;<span>作业列表</span>
		</div>
		<el-container class="content">
			<div class=" zy_content clearfix">
				<div class="zy_index_title">
					<img src="@/images/title_back1.png" class="zy_index_titleback" />
					<img src="@/images/zy-title7.png" class="zy_index_titlename" />
					<div class="zy_index_titleright clearfix">
						<!--<div class="zy_index_titlerightinput clearfix" v-show="false">
							<el-select class="zy_index_titlerightselect" placeholder="请选择课程" @change="getTaskList" clearable v-model='form.courseId' size='small' style='width: 100%;float: left;'>
								<el-option v-for="item in courses" :value='item.id' :label='item.name'></el-option>
							</el-select>
						</div>-->
						<div class="zy_index_titlerightinput clearfix">
							<el-input placeholder="请输入课程名称" @input='getTaskList' clearable prefix-icon="el-icon-search" v-model='form.courseName' size='small' style='width: 100%;float: left;'></el-input>
						</div>
						<div class="zy_index_titlerightitem" :class="form.isFinish == null ?'active':''" @click="typeChange(null)">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo">全部</div>
						</div>
						<div class="zy_index_titlerightitem" :class="item.value == form.isFinish ?'active':''" v-for="(item, index) in types" :key="'type' + index" @click="typeChange(item.value)">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo text-ellipsis">{{item.label}}</div>
						</div>
					</div>
				</div>
				<div class="zy_maincont clearfix">
					<div v-if="!taskList || taskList.length<=0" class="simulation_empty_msg_content">暂无作业</div>
					<div class="clearfix" v-if="taskList && taskList.length>0">
						<el-table :data="taskList" stripe style="width: 100%;margin: 0 0 20px 0;">
							<el-table-column prop="name" label="作业名称">
								<template slot-scope="scope">
									<span style="color: red;margin: 0 5px 0 0 ;" v-show='getNew(scope.row)'>[新]</span>{{scope.row.name}}
								</template>
							</el-table-column>
							<el-table-column label="创建时间" align="center">
								<template slot-scope="scope">
									{{scope.row.createTime | spliceForTask}}
								</template>
							</el-table-column>
							<el-table-column prop="createUsername" label="发布人" align="center">
							</el-table-column>
							<el-table-column prop="topicNum" label="题目数量" align="center">
							</el-table-column>
							<el-table-column prop="sumScore" label="总分" align="center">
							</el-table-column>
							<el-table-column prop="passScore" label="及格分" align="center">
							</el-table-column>
							<el-table-column prop="courseName" label="所属课程" align="center">
							</el-table-column>
							<el-table-column label="操作" width='200' align="center">
								<template slot-scope="scope">
									<el-button size="mini" type="primary" @click="start(scope.row)" v-if='!scope.row.isFinish'>进入作业</el-button>
									<el-button size="mini" type="primary" @click="info(scope.row.id)" v-if='scope.row.isFinish'>查看结果</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="all_live_page" v-if="taskList && taskList.length>0">
						<el-pagination background @current-change="taskPageChange" :current-page="taskPage" :page-size="pageSize" layout="prev, pager, next" :total="tasktotalRow">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import { ourAllTaskList } from '@/api/task.js'
	import { appCourseList } from '@/api/course'
	export default {
		data() {
			return {
				form: {
					isFinish:null,
					courseId:"",
					courseName:"",
				},
				courses:[],
				types: [{
					value: '0',
					label: '未完成'
				}, {
					value: '1',
					label: '已完成'
				}],
				pageSize: 10,
				taskPage: 1,
				tasktotalRow: 0,
				taskList: [],
				test: false,
				testform: {
					topicAmount: 0,
				},
			}
		},
		created() {
			this.getCourse()
			this.getTaskList()
		},
		mounted() {

		},
		methods: {
			getCourse() {
				var data = {
					major_id: this.majorIdForAll,
					page: 1,
					pageSize: 100,
				}
				appCourseList(data).then(res => {
					if(res.code == 0) {
						this.courses = res.data.listData;
					}
				})
			},
			getNew(item) {
				if(item.beginTime && item.endTime) {
					var nowTime = new Date();
					var beginTime = new Date(item.beginTime.split('T').join(' '));
					var endTime = new Date(item.endTime.split('T').join(' '));
					if(nowTime < beginTime) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
			typeChange(isFinish) {
				this.form.isFinish = isFinish;
				this.getTaskList();
			},
			taskPageChange(page) {
				this.taskPage = page;
				this.getTaskList()
			},
			getTaskList() {
				var data = {
					isFinish: this.form.isFinish,
					courseId: this.form.courseId || null,
					courseName: this.form.courseName || null,
					pageSize: this.pageSize,
					page: this.taskPage
				}
				ourAllTaskList(data).then(res => {
					if(res.code == 0) {
						this.tasktotalRow = res.data.totalRow;
						this.taskList = res.data.listData
					}
				})
			},
			start(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime.split('T').join(' '));
				var endTime = new Date(item.endTime.split('T').join(' '));
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '作业时间未到！',
					})
					return;
				}
				if(nowTime > endTime && item.isDelay == '0') {
					this.$message({
						type: 'info',
						message: '作业时间已结束！',
					})
					return;
				}
				this.$router.push({
					name: 'task',
					query: {
						taskId: item.id
					}
				})
			},
			info(id) {
				this.$router.push({
					name: 'taskdetails',
					query: {
						taskId: id
					}
				})
			},
		},
		beforeRouteLeave(to, from, next) {
			next();
		},
	}
</script>

<style>

</style>